//@ts-nocheck
import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { useAlert } from 'react-alert';
import { useDispatch } from 'react-redux';
import { Container, Row, Col, Card } from 'react-bootstrap';
import {
  getStorageItems,
  deleteStorageItem,
} from 'services/apiRequests/storage.api';
import { getGlobalSettings } from 'services/store/actions/settings';
import { setSpinner } from 'services/store/actions/view';
import StorageItemsList from './StorageItemsList';
import ConfirmationModal from 'components/modals/ConfirmationModal';

const StorageItemsTab = forwardRef(({ onEdit, onUpdateQuantity }, ref) => {
  const dispatch = useDispatch();
  const alert = useAlert();
  const [storageItems, setStorageItems] = useState([]);
  const [deleteConfirmation, setDeleteConfirmation] = useState(null);

  const fetchStorageItems = async () => {
    try {
      const data = await getStorageItems();
      setStorageItems(data.items);
    } catch (error) {
      alert.error('Błąd pobierania elementów magazynowych');
    }
  };

  useImperativeHandle(ref, () => ({
    refreshItems: fetchStorageItems,
  }));

  useEffect(() => {
    dispatch(setSpinner(true));
    Promise.all([
      dispatch(
        getGlobalSettings(
          () => {},
          () => {
            alert.error('Błąd!');
          },
        ),
      ),
      fetchStorageItems(),
    ]).finally(() => {
      dispatch(setSpinner(false));
    });
  }, []);

  const handleEdit = (item) => {
    if (onEdit) {
      onEdit(item);
    }
  };

  const handleDelete = (item) => {
    setDeleteConfirmation(item);
  };

  const confirmDelete = async () => {
    if (!deleteConfirmation) return;

    try {
      dispatch(setSpinner(true));
      await deleteStorageItem(deleteConfirmation._id);
      alert.success('Produkt został usunięty pomyślnie!');
      await fetchStorageItems(); // Odśwież listę po usunięciu
    } catch (error) {
      console.error('Błąd podczas usuwania produktu:', error);
      alert.error('Błąd podczas usuwania produktu');
    } finally {
      dispatch(setSpinner(false));
      setDeleteConfirmation(null);
    }
  };

  const cancelDelete = () => {
    setDeleteConfirmation(null);
  };

  return (
    <Container fluid className="py-3">
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <h5 className="mb-0">Elementy magazynowe</h5>
            </Card.Header>
            <Card.Body>
              {/* Informacje o elementach */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <small className="text-muted">
                    Łącznie {storageItems.length} elementów w magazynie
                  </small>
                </div>
              </div>

              {/* Lista elementów */}
              <StorageItemsList
                items={storageItems}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onUpdateQuantity={onUpdateQuantity}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {deleteConfirmation && (
        <ConfirmationModal
          title="Potwierdzenie usunięcia"
          description={
            <div>
              <p>
                Czy na pewno chcesz usunąć produkt:{' '}
                <strong>"{deleteConfirmation.name}"</strong>
              </p>

              <p>Ta operacja jest nieodwracalna.</p>
            </div>
          }
          handleSubmit={confirmDelete}
          closeModal={cancelDelete}
        />
      )}
    </Container>
  );
});

export default StorageItemsTab;
